const generateURLBasedOnPath = (path, isHash = false) => (`//${window.location.host}${ isHash ? '/#' : '/' }${path}`)

exports.generateURLBasedOnPath = generateURLBasedOnPath;